<template>
    <div class="muven-card">
        <p v-if="!message">Nada encontrado</p>
        <p v-if="message">{{message}}</p>
    </div>    
</template>

<script>
export default {
    name: 'NothingFoundCmp',
    props: {
        message: {
            type: String,
            required: true,
            default: '',
        },
    },
}
</script>

<style lang="scss" scoped>
.muven-card {
    p {
        text-align: left;
        margin: 0;
    }
}
</style>